import Button from "../../components/Button";
import { TrackingUtil } from "../../utils/tracking";import { DataType, DataListType, IWidget, ACTION_VARIANT, CardStyle } from "../../types";
import { DOM } from "../../utils/domActions";

class HorizontalCardList implements IWidget {
    container: HTMLElement | null = null;
    listData: DataListType | null = null;
    items: DataType[] = [];
    campaignId: string | null = null;    cardMaxWidth: string = "280px"; // Default max-width 280px
    
    render(): HTMLElement {
        console.log("HorizontalCardList render");
        if (!this.container) {
            this.container = DOM.createElement("div", {
                id: "trustshop-embed-horizontal-card-list--container",
                className: "trustshop-embed-horizontal-card-list--container",
            });
        }

        // Get max-width from global card style if available
        if (window.TS_CARD_STYLE?.maxWidth) {
            this.cardMaxWidth = window.TS_CARD_STYLE.maxWidth;
        }

        // Create cards container
        const cardsContainer = DOM.createElement("div", {
            className: "trustshop-embed-horizontal-card-list--cards",
        });

        console.log("Rendering cards:", this.items);

        this.items.forEach((data) => {
            const card = this.renderCard(data);
            cardsContainer.appendChild(card);
        });

        this.container.appendChild(cardsContainer);

        return this.container;
    }

    renderCard(data: DataType): HTMLElement {
        const card = DOM.createElement("div", {
            className: "trustshop-embed-horizontal-card-list--card",
            attributes: {
                style: `max-width: ${this.cardMaxWidth}`,
            }
        });

        // Card inner wrapper for border and padding
        const cardInner = DOM.createElement("div", {
            className: "trustshop-embed-horizontal-card-list--card-inner",
        });

        // Image/Icon at top on its own line
        if (data.img_url || data.icon) {
            const imageWrapper = DOM.createElement("div", {
                className: "trustshop-embed-horizontal-card-list--card-image",
            });

            if (data.img_url) {
                const img = DOM.createElement("img", {
                    attributes: {
                        src: data.img_url,
                        alt: data.title || "Card image",
                    },
                });
                imageWrapper.appendChild(img);
            } else if (data.icon) {
                // If icon is provided instead of image
                const iconDiv = DOM.createElement("div", {
                    className: "trustshop-embed-horizontal-card-list--card-icon",
                    innerHTML: data.icon,
                });
                imageWrapper.appendChild(iconDiv);
            }

            cardInner.appendChild(imageWrapper);
        }

        // Content section
        const content = DOM.createElement("div", {
            className: "trustshop-embed-horizontal-card-list--card-content",
        });

        // Title
        if (data.title) {
            const title = DOM.createElement("h3", {
                className: "trustshop-embed-horizontal-card-list--card-title",
                textContent: data.title,
            });
            content.appendChild(title);
        }

        // Description
        if (data.description) {
            const description = DOM.createElement("p", {
                className: "trustshop-embed-horizontal-card-list--card-description",
                textContent: data.description,
            });
            content.appendChild(description);
        }

        cardInner.appendChild(content);

        // Actions at bottom
        if (data.primary_action || data.secondary_actions) {
            const actionsContainer = DOM.createElement("div", {
                className: "trustshop-embed-horizontal-card-list--card-actions",
            });

            // Primary action
            if (data.primary_action) {
                const actionBtn = Button.create({
                    ...data.primary_action,
                    variant: data.primary_action.variant || ACTION_VARIANT.SECONDARY,
                    className: "trustshop-embed-horizontal-card-list--card-action",
                });
                actionsContainer.appendChild(actionBtn);
            }

            // Secondary actions
            if (data.secondary_actions) {
                const secondaryActions = Array.isArray(data.secondary_actions) 
                    ? data.secondary_actions 
                    : [data.secondary_actions];

                secondaryActions.forEach((action) => {
                    const actionBtn = Button.create({
                        ...action,
                        variant: action.variant || ACTION_VARIANT.PLAIN,
                        className: "trustshop-embed-horizontal-card-list--card-secondary",
                    });
                    actionsContainer.appendChild(actionBtn);
                });
            }

            cardInner.appendChild(actionsContainer);
        }

        card.appendChild(cardInner);
        return card;
    }

    show(): void {
        if (this.container) {
            this.container.style.display = "block";
        }
    }

    hide(): void {
        if (this.container) {
            this.container.style.display = "none";
        }
    }

    destroy(): void {
        if (this.container) {
            this.container.remove();
            this.container = null;
        }
    }

    isVisible(): boolean {
        return this.container ? this.container.style.display !== "none" : false;
    }

    toggle(): void {
        if (this.isVisible()) {
            this.hide();
        } else {
            this.show();
        }
    }

    updateData(data: DataListType | DataType | DataType[]): void {
        // Check if it's a DataListType with title, subtitle, and data array
        if (data && "data" in data && Array.isArray(data.data)) {
            // Store the full DataListType object
            this.listData = data as DataListType;
            this.items = data.data.filter(Boolean) as DataType[];
        } else if (Array.isArray(data)) {
            // Direct array of items
            this.items = data;
            this.listData = null;
        } else {
            // Single item, wrap in array
            this.items = [data as DataType];
            this.listData = null;
        }
    }
}

const HorizontalCardListInstance = new HorizontalCardList();

export default HorizontalCardListInstance;